import { useTranslation } from 'react-i18next'

export const displayGroup = (group: string) => {
	const { t } = useTranslation('pages_notifications')

	switch (group) {
		case 'today':
			return t('today', { ns: 'common' })
		case 'yesterday':
			return t('yesterday', { ns: 'common' })
		case 'thisWeek':
			return t('tallaViikolla')
		case 'lastWeek':
			return t('viimeViikolla')
		case 'lastMonth':
			return t('viimeKuussa')
		default:
			return t('aikojaSitten')
	}
}
